var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.601,
    height: 18.601,
    viewBox: "0 0 18.601 18.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1b515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#fffb9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1900b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5866",
    "data-name": "Group 5866",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5864",
    "data-name": "Group 5864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M19.02,2.163H16.114V1.523A.573.573,0,0,0,15.532,1H5.069a.573.573,0,0,0-.581.523c0,.233-.058.407-.058.639H1.581A.583.583,0,0,0,1,2.744v.7a6.263,6.263,0,0,0,5.348,6.22A16.461,16.461,0,0,0,7.51,11.289h5.58a7.62,7.62,0,0,0,1.163-1.628A6.353,6.353,0,0,0,19.6,3.441v-.7a.625.625,0,0,0-.581-.581ZM2.163,3.441V3.325H4.43A12.08,12.08,0,0,0,5.592,8.266a5.084,5.084,0,0,1-3.43-4.825ZM12.626,6.115l-.814.814.174,1.163a.482.482,0,0,1-.174.465.444.444,0,0,1-.291.116.349.349,0,0,1-.233-.058L10.3,8.092l-.988.523a.443.443,0,0,1-.523-.058.389.389,0,0,1-.174-.465l.174-1.163-.814-.814a.558.558,0,0,1-.116-.523.615.615,0,0,1,.407-.349l1.1-.174.523-1.046a.46.46,0,0,1,.465-.291.593.593,0,0,1,.465.291l.523,1.046,1.1.174a.615.615,0,0,1,.407.349,1.436,1.436,0,0,1-.233.523Zm5.813-2.674a5.084,5.084,0,0,1-3.43,4.825,12.553,12.553,0,0,0,1.1-4.941h2.325Zm-5.871,8.952H8.034A4.174,4.174,0,0,1,6.7,15.184a.313.313,0,0,0,.233.523h6.859a.313.313,0,0,0,.233-.523A4.1,4.1,0,0,1,12.568,12.393Z",
    transform: "translate(-1 -1)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5865",
    "data-name": "Group 5865",
    transform: "translate(4.65 15.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M17.777,28.4H9.523A.521.521,0,0,0,9,28.923v1.569a.549.549,0,0,0,.581.581h8.138a.549.549,0,0,0,.581-.581V28.865A.512.512,0,0,0,17.777,28.4Z",
    transform: "translate(-9 -28.4)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.27952b685825ca3fad9ff44856f77f4e.svg";
export { ForwardRef as ReactComponent };